import { render, staticRenderFns } from "./turnOffDialog.vue?vue&type=template&id=7b8cdc07&"
import script from "./turnOffDialog.vue?vue&type=script&lang=js&"
export * from "./turnOffDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports